import { handleAppUrlOpen } from '@/actions/IntentURL'
import { useAuthStore } from '@/stores/AuthStore'
import { useLocationStore } from '@/stores/LocationStore'
import { useEmployeeStore } from '@/stores/EmployeeStore'
import { useEventStore } from '@/stores/EventStore'
import { useProjectStore } from '@/stores/ProjectStore'
import { useConfigStore } from '@/stores/ConfigStore'
import { getDeviceStores, getUserStoresToSync } from '@/stores'
import StoreManager from '@/classes/manager/StoreManager'
import { registerOngoingNotification } from '@/composables/useLocalNotifications'
import { killCurrentOngoingNotifications } from '@/composables/useLocalNotifications'
import { navigateToCurrentTaskPage } from './router/actions/navigateToCurrentTaskPage'
import {
  afterAppBecomesActive,
  afterAppBecomesInactive,
  afterNetworkBecomesActive,
  afterNetworkBecomesInactive,
  afterAppUrlOpen,
} from '@/appStateHooks'
import { useAmplitudeStore } from './stores/AmplitudeStore'
import { useAppStateStore } from './stores/AppStateStore'

export default function handleAppStateChanges() {
  afterAppBecomesActive(async () => {
    void killCurrentOngoingNotifications()
    const authStore = useAuthStore()
    const eventStore = useEventStore()
    const employeeStore = useEmployeeStore()
    const configStore = useConfigStore()
    const appStateStore = useAppStateStore()

    appStateStore.appBackgroundedByPermissionCheck = false

    if (employeeStore.employee?.id && configStore.amplitude_api_key) {
      useAmplitudeStore().addAppOpenedEvent(employeeStore.employee.id)
    }

    //prevents hook to be called in registration and login process
    if (!authStore.deviceIsAuthenticated) return
    void StoreManager.registerForBackgroundSync([useLocationStore()])
    await eventStore.sync()

    void StoreManager.sync(
      getDeviceStores().filter(
        (store) =>
          store.$id !== eventStore.$id && store.$id !== useProjectStore().$id,
      ),
    )
    if (
      authStore.userIsAuthenticated &&
      employeeStore.employee?.can_visit_my_area
    ) {
      void StoreManager.sync(getUserStoresToSync(employeeStore.employee))
    }
    if (authStore.isTeamDevice) {
      if (
        employeeStore.employee &&
        employeeStore.teamleader &&
        employeeStore.employee.id !== employeeStore.teamleader.id
      ) {
        employeeStore.setActiveEmployee(employeeStore.teamleader)
      }
    }
    if (!import.meta.env.DEV) {
      void navigateToCurrentTaskPage(true)
    }
    configStore.updateAppVersionLabel()
  })

  afterAppBecomesInactive(() => {
    const employeeStore = useEmployeeStore()
    const configStore = useConfigStore()
    const authStore = useAuthStore()

    if (!authStore.deviceIsAuthenticated) return

    if (employeeStore.employee?.id && configStore.amplitude_api_key) {
      useAmplitudeStore().addAppClosedEvent(employeeStore.employee?.id)
    }
    void registerOngoingNotification()
  })

  afterNetworkBecomesActive(() => {
    if (useAuthStore().deviceIsAuthenticated) {
      void StoreManager.sync(getDeviceStores())
    }
    const employee = useEmployeeStore().employee
    if (useAuthStore().userIsAuthenticated && employee) {
      void StoreManager.sync(getUserStoresToSync(employee))
    }
  })

  afterNetworkBecomesInactive(() => {
    //
  })

  afterAppUrlOpen(handleAppUrlOpen)
}
